!function() {
    "use strict";

    var modules = {
        1310: function(module, exports, require) {
            var Swiper = require(2402).Z;
            var mobileQuery = window.matchMedia("(max-width: 767px)");

            document
                .querySelectorAll(".features-bar__inner-container:not(.feature_search_slider)")
                .forEach(function(container) {
                    if (!container.querySelector(".swiper-wrapper, .swiper-slide")) return;

                    var slider = null;
                    var previousButton = container.querySelector(".swiper-button-prev");
                    var nextButton = container.querySelector(".swiper-button-next");

                    function createSlider() {
                        if (slider && !slider.destroyed) return;

                        var options = {
                            autoplay: { delay: 3000 },
                            speed: 800,
                            loop: true,
                            slidesPerView: 1,
                            centeredSlides: true,
                            watchSlidesProgress: true
                        };

                        if (previousButton && nextButton) {
                            options.navigation = {
                                nextEl: nextButton,
                                prevEl: previousButton
                            };
                        }

                        slider = new Swiper(container, options);
                    }

                    function destroySlider() {
                        if (!slider || slider.destroyed) return;
                        slider.destroy(true, true);
                        slider = null;
                    }

                    function syncSlider() {
                        if (container.classList.contains("swiper-all") || mobileQuery.matches) {
                            createSlider();
                        } else {
                            destroySlider();
                        }
                    }

                    syncSlider();
                    mobileQuery.addEventListener("change", syncSlider);
                });
        }
    };
    var cache = {};

    function require(id) {
        var cachedModule = cache[id];
        if (void 0 !== cachedModule) return cachedModule.exports;

        var module = cache[id] = { exports: {} };
        modules[id].call(module.exports, module, module.exports, require);
        return module.exports;
    }

    require.m = modules;
    require.d = function(exports, definition) {
        for (var key in definition) {
            require.o(definition, key) &&
                !require.o(exports, key) &&
                Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
        }
    };
    require.o = function(object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    require.j = 4671;

    var deferred = [];
    require.O = function(result, chunkIds, fn, priority) {
        if (!chunkIds) {
            var notFulfilled = 1 / 0;
            for (var i = 0; i < deferred.length; i++) {
                chunkIds = deferred[i][0];
                fn = deferred[i][1];
                priority = deferred[i][2];
                var fulfilled = true;

                for (var j = 0; j < chunkIds.length; j++) {
                    if (
                        (!priority || notFulfilled >= priority) &&
                        Object.keys(require.O).every(function(key) {
                            return require.O[key](chunkIds[j]);
                        })
                    ) {
                        chunkIds.splice(j--, 1);
                    } else {
                        fulfilled = false;
                        if (priority < notFulfilled) notFulfilled = priority;
                    }
                }

                if (fulfilled) {
                    deferred.splice(i--, 1);
                    var returned = fn();
                    if (void 0 !== returned) result = returned;
                }
            }
            return result;
        }

        priority = priority || 0;
        var insertAt = deferred.length;
        while (insertAt > 0 && deferred[insertAt - 1][2] > priority) {
            deferred[insertAt] = deferred[insertAt - 1];
            insertAt--;
        }
        deferred[insertAt] = [chunkIds, fn, priority];
    };

    !function() {
        var installedChunks = { 4671: 0 };
        require.O.j = function(chunkId) {
            return installedChunks[chunkId] === 0;
        };

        var webpackJsonpCallback = function(parentCallback, data) {
            var moduleId;
            var chunkId;
            var moreModules = data[1];
            var runtime = data[2];
            var chunkIds = data[0];
            var result = 0;

            if (chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
                for (moduleId in moreModules) {
                    if (require.o(moreModules, moduleId)) require.m[moduleId] = moreModules[moduleId];
                }
                if (runtime) result = runtime(require);
            }

            if (parentCallback) parentCallback(data);

            for (; result < chunkIds.length; result++) {
                chunkId = chunkIds[result];
                if (require.o(installedChunks, chunkId) && installedChunks[chunkId]) {
                    installedChunks[chunkId][0]();
                }
                installedChunks[chunkId] = 0;
            }

            return require.O(result);
        };

        var chunkLoadingGlobal = self.webpackChunkworkflow = self.webpackChunkworkflow || [];
        chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
        chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
    }();

    var result = require.O(void 0, [1216], function() {
        return require(1310);
    });
    result = require.O(result);
}();
